const LOCALE = 'en-US';

export const customScaleFormatter = (
  number: number,
  minDecimal: number,
  maxDecimal: number,
) =>
  number.toLocaleString(LOCALE, {
    minimumFractionDigits: minDecimal,
    maximumFractionDigits: maxDecimal,
  });

export const formatValue = (scale: number) => (value: number) =>
  customScaleFormatter(value, scale, scale);

export const formatValueDynamic = (scale: number, max = 10) => (
  value: number,
) => customScaleFormatter(value, scale, max);

export const numberFormatter = (
  unit: string,
  number: number,
  scale: number,
) => {
  const ifNegative = number < 0 ? '-$' : '$';

  switch (unit) {
    case '$':
      return `${ifNegative}${formatValue(scale)(Math.abs(number))}`;
    case '%':
      return `${formatValue(scale)(number * 100)}%`;
    case 'kg':
      return `${formatValueDynamic(scale)(number)} kg`;
    default:
      return `${formatValue(scale)(number)} ${unit}`;
  }
};

export const dollarFormatter = (number: number, scale = 2) =>
  numberFormatter('$', number, scale);
export const percentageFormatter = (number: number, decimal = 0) =>
  numberFormatter('%', number, decimal);
export const kilogramFormatter = (number: number, scale = 2) =>
  numberFormatter('kg', number, scale);
